import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import google from 'assets/google.png';
import './_SocialButton.scss';

const iconsImages = {
  google,
};

export const SocialButton = ({
  icon, text, isImage, ...props
}) => (
  <button type='button' {...props} className={`social__button social__button-${icon}`}>
    {isImage
      ? (
        <img
          alt={`${icon} icon`}
          className={`social__button-${icon}__icon`}
          src={iconsImages[icon]}
        />
      )
      : (
        <Icon
          className={`social__button-${icon}__icon`}
          name={icon}
        />
      )}
    <p className='social__button__text'>{text}</p>
  </button>
);

SocialButton.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string,
  isImage: PropTypes.bool,
};

export default SocialButton;
